// ASL1 IMPERIESE
export const ID_IMPERIA = "07000101";
export const ID_SANREMO = "07000102";
export const ID_BORDIGHERA = "07000103";
// ASL2 SAVONESE
export const ID_SANTA_CORONA = "07021102";
export const ID_SANTA_MARIA_MISERICORDIA = "07021101";
export const ID_SAN_GIUSEPPE = "07021203";
export const ID_SAN_PAOLO = "07021204";
// ASL3 GENOVESE
export const ID_LA_COLLETTA = "07030101";
export const ID_MICONE = "07030103";
export const ID_VILLA_SCASSI = "07030104";
export const ID_GALLINO = "07030105";
// ASL4 CHIAVARESE
export const ID_RIBOLI = "07003901";
export const ID_SESTRI_LEVANTE = "07003902";
export const ID_MONTALLEGRO = "07003905";
// ASL5 SPEZZINO
export const ID_LA_SPEZIA = "07005801";
export const ID_LEVANTO = "07005803";
export const ID_SARZANA = "07005804";
// GALLIERA
export const ID_GALLIERA = "070025";
// S.MARTINO
export const ID_SAN_MARTINO = "070901";
// GASLINI
export const ID_GASLINI = "070940";
// EVANGELICO
export const ID_EVANGELICO_CASTELLETTO = "07005101";
export const ID_EVANGELICO_VOLTRI = "07005102";
